import { combineEpics } from 'redux-observable';
import customersGet from './customersGet';
import customerUpdate from './customerUpdate';
import estimationPeriodsGet from './estimationPeriodsGet';
import estimationPeriodUpdate from './estimationPeriodUpdate';
import customersDelete from './customersDelete';
import resetPassword from './resetPassword';

export default combineEpics(customerUpdate, customersGet, customersDelete, resetPassword, estimationPeriodsGet, estimationPeriodUpdate);



// WEBPACK FOOTER //
// ./src/application/admin/epic/index.ts